import * as React from 'react';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {StyledTableCell} from "../mui/StyledTableCell";
import StyledTableContainer from "../mui/StyledTableContainer";
import {StyledTableRow} from "../mui/StyledTableRow";
import {HeaderClass} from "../../models/class/HeaderClass";
import {MilestoneTypeDTO} from "../../models/dto/MilestoneType";
import {v4 as uuidv4} from "uuid";
import useModal from "../../hooks/useModal";
import ApolloLazyQueryDialogContext from "../query/ApolloLazyQueryDialogContextWrapper";
import GET_MILESTONE_TYPE_BY_ID from "../../GraphQL/Queries/get-milestone-type-by-id";
import MilestoneTypeDialogContent from "./MilestoneTypeDialogContent";

export default ({allMilestonesTypesDTO, headerClass}: {
    allMilestonesTypesDTO: ReadonlyArray<MilestoneTypeDTO>,
    headerClass: HeaderClass
}) => {
    const modalValues = useModal();
    return (
        <>
            <StyledTableContainer>
                <>
                    <TableHead>
                        <TableRow>
                            {headerClass.labels.map(headerLabel => (
                                <StyledTableCell align="left">{headerLabel}</StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allMilestonesTypesDTO.map((row) => (
                            <StyledTableRow style={{cursor: 'pointer'}}
                                            onClick={() => modalValues.handleModalId(String(row.id))} key={uuidv4()}>
                                <StyledTableCell align="left">{row.name}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </>
            </StyledTableContainer>
            <ApolloLazyQueryDialogContext
                modalValues={modalValues}
                documentNode={GET_MILESTONE_TYPE_BY_ID}
            >
                <MilestoneTypeDialogContent/>
            </ApolloLazyQueryDialogContext>
        </>
    );
}
